import type { FC, ReactNode } from 'react';
import type { DehydratedState } from '@tanstack/react-query';

import { useState } from 'react';
import { HydrationBoundary } from '@tanstack/react-query';

import { keepServerAnswers } from 'src/queries/serverRendered';

interface ServerAnswersProps {
  /**
   * What the server's loader gave this page (`src/server/*.server.ts`) — `null` on every later
   * visit to the route, which the browser makes on its own.
   */
  rendered: { dehydratedState: DehydratedState } | null | undefined;
  children: ReactNode;
}

/**
 * Puts the answers the server rendered a page with where the screen's own queries look for them,
 * so the screen renders the same cars on the server, in the browser's first render and after it —
 * without a request of its own (storefront-catalog spec §4.5).
 */
export const ServerAnswers: FC<ServerAnswersProps> = ({ rendered, children }) => {
  const state = rendered?.dehydratedState;

  // Once, before the screen's queries mount: these answers are a moment old and are not re-asked.
  useState(() => {
    if (!import.meta.env.SSR) keepServerAnswers(state);

    return null;
  });

  return <HydrationBoundary state={state}>{children}</HydrationBoundary>;
};
